export const LANG_STORAGE_KEY = 'AI_CONNECT_LANG'
export const AVAILABLE_LANGS = ['UZ', 'EN', 'RU']
